export function findVisualCenter(canvas) {
    // Create a temporary canvas to work with the image data
    const tempCanvas = document.createElement("canvas");
    tempCanvas.width = canvas.width;
    tempCanvas.height = canvas.height;
    const tempCtx = tempCanvas.getContext("2d");
    tempCtx.drawImage(canvas, 0, 0);

    // Get image data to analyze
    const imageData = tempCtx.getImageData(0, 0, canvas.width, canvas.height);
    const data = imageData.data;
    const width = canvas.width;
    const height = canvas.height;

    // Find the bounds of non-transparent pixels
    const bounds = cropBounds(data, width, height);
    if (!bounds) {
        // If the image is fully transparent, return the center
        return [width / 2, height / 2];
    }

    const [minX, minY, cropWidth, cropHeight] = bounds;
    
    // Return the center of the non-transparent area
    return [minX + cropWidth / 2, minY + cropHeight / 2];
}

export function getVisibleDimensions(canvas) {
    // Create a temporary canvas to work with the image data
    const tempCanvas = document.createElement("canvas");
    tempCanvas.width = canvas.width;
    tempCanvas.height = canvas.height;
    const tempCtx = tempCanvas.getContext("2d");
    tempCtx.drawImage(canvas, 0, 0);

    // Get image data to analyze
    const imageData = tempCtx.getImageData(0, 0, canvas.width, canvas.height);
    const data = imageData.data;
    const width = canvas.width;
    const height = canvas.height;

    // Find the bounds of non-transparent pixels
    const bounds = cropBounds(data, width, height);
    if (!bounds) {
        // Return 1x1 if the image is fully transparent
        return { width: 1, height: 1 };
    }

    const [minX, minY, cropWidth, cropHeight] = bounds;
    return { width: cropWidth, height: cropHeight };
}

export function cropTransparentImage(canvas, includeCropBounds = false) {
    // Create a temporary canvas to work with the image data
    const tempCanvas = document.createElement("canvas");
    tempCanvas.width = canvas.width;
    tempCanvas.height = canvas.height;
    const tempCtx = tempCanvas.getContext("2d");
    tempCtx.drawImage(canvas, 0, 0);

    // Get image data to analyze
    const imageData = tempCtx.getImageData(0, 0, canvas.width, canvas.height);
    const data = imageData.data;
    const width = canvas.width;
    const height = canvas.height;

    // Find the bounds of non-transparent pixels
    const bounds = cropBounds(data, width, height);
    if (!bounds) {
        // Return a small canvas if the image is fully transparent
        const emptyCanvas = document.createElement("canvas");
        emptyCanvas.width = 1;
        emptyCanvas.height = 1;
        
        return includeCropBounds ? [emptyCanvas, [0, 0, 1, 1]] : emptyCanvas;
    }

    const [minX, minY, cropWidth, cropHeight] = bounds;
    
    // Create a new canvas for the cropped image
    const croppedCanvas = document.createElement("canvas");
    croppedCanvas.width = cropWidth;
    croppedCanvas.height = cropHeight;
    const croppedCtx = croppedCanvas.getContext("2d");
    
    // Draw the cropped portion
    croppedCtx.drawImage(
        canvas,
        minX, minY, cropWidth, cropHeight,
        0, 0, cropWidth, cropHeight
    );
    
    return includeCropBounds ? [croppedCanvas, bounds] : croppedCanvas;
}

// Helper function to find the bounds of the non-transparent area
function cropBounds(data, width, height) {
    let minX = width;
    let minY = height;
    let maxX = 0;
    let maxY = 0;
    let hasVisible = false;
    
    // Scan the image data to find non-transparent pixels
    for (let y = 0; y < height; y++) {
        for (let x = 0; x < width; x++) {
            const idx = (y * width + x) * 4;
            const alpha = data[idx + 3];
            
            if (alpha > 0) {
                hasVisible = true;
                if (x < minX) minX = x;
                if (y < minY) minY = y;
                if (x > maxX) maxX = x;
                if (y > maxY) maxY = y;
            }
        }
    }
    
    if (!hasVisible) {
        return null;
    }
    
    const cropWidth = maxX - minX + 1;
    const cropHeight = maxY - minY + 1;
    
    return [minX, minY, cropWidth, cropHeight];
}